export const actionTypes = {
    FetchOrders: 'SR_FETCH_ORDERS',
    FetchOrder: 'SR_FETCH_ORDER',
    FetchedOrders: 'SR_FETCHED_ORDERS',
    FetchedOrder: 'SR_FETCHED_ORDER',
    FetchOrdersFailed: 'SR_FETCH_ORDER_FAILED',
    FetchOrderFailed: 'SR_FETCH_ORDER_FAILED',
    SetOrdersTotalRecords: 'SR_SET_ORDERS_TOTALRECORDS',
};

const initialState = {
    loading: false,
    orders: [],
    totalRecords: {
        in_progress: 0,
        closed: 0,
    },
    filtersContent: [],
    order: null,
    error: null,
};

export function orderSmartRepairReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FetchOrders:
        case actionTypes.FetchOrder: {
            return {
                ...state,
                loading: true,
                order: null,
                error: null,
            };
        }
        case actionTypes.FetchedOrders: {
            return {
                ...state,
                loading: false,
                orders: action.payload.orders,
                filtersContent: action.payload.filters,
            };
        }
        case actionTypes.FetchedOrder: {
            return {
                ...state,
                loading: false,
                order: action.payload,
            };
        }
        case actionTypes.FetchOrderFailed:
        case actionTypes.FetchOrdersFailed: {
            return {
                ...state,
                loading: false,
                orders: [],
                error: action.payload.error,
            };
        }
        case actionTypes.SetOrdersTotalRecords: {
            return {
                ...state,
                totalRecords: action.payload,
            };
        }
        default:
            return state;
    }
}

export const actions = {
    fetchOrders: () => ({ type: actionTypes.FetchOrders }),
    fetchedOrders: (orders) => ({ type: actionTypes.FetchedOrders, payload: orders }),
    fetchOrder: () => ({ type: actionTypes.FetchOrder }),
    fetchedOrder: (order) => ({ type: actionTypes.FetchedOrder, payload: order }),
    fetchOrderFailed: (error) => ({ type: actionTypes.FetchOrderFailed, payload: error }),
    fetchOrdersFailed: (error) => ({ type: actionTypes.FetchOrdersFailed, payload: error }),
    setOrdersTotalRecords: (totalRecords) => ({ type: actionTypes.SetOrdersTotalRecords, payload: totalRecords }),
};
